var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarLarge = function SvgStarLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 134,
    fill: "none",
    viewBox: "0 0 88 134"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#902EEF",
    d: "M63.779 2.532c1.332-3.376 6.11-3.376 7.442 0l16.43 41.66a4 4 0 0 0 2.254 2.254l41.66 16.43c3.377 1.332 3.377 6.11 0 7.443l-41.66 16.43a4 4 0 0 0-2.254 2.254l-16.43 41.66c-1.332 3.376-6.11 3.376-7.442 0l-16.43-41.66a4 4 0 0 0-2.254-2.254L3.435 70.32c-3.377-1.332-3.377-6.11 0-7.443l41.66-16.43a4 4 0 0 0 2.253-2.253z"
  })));
};
export default SvgStarLarge;